// extracted by mini-css-extract-plugin
module.exports = {"component":"my-trip_component__yFIdR","wrapper":"my-trip_wrapper__5W4aF","innerWrapper":"my-trip_innerWrapper__V0TFr","hideMainNavigation":"my-trip_hideMainNavigation__0d_jK"};